import React, { Component } from 'react';

export default class ModalConnectionError extends Component {
    render () {
        return (
            <div
                id="modal_connection_error"
                style={{
                    height: '100%',
                    width: '100%',
                    padding: '5rem',
                    boxSizing: 'border-box',
                    zIndex: '10000',
                    position: 'absolute',
                    display: 'none'
                }}>
                <div style={{
                    background: 'black',
                    borderRadius: '.5rem',
                    color: 'white',
                    height: '100%',
                    padding: '3rem',
                    opacity: '.95'
                }}>
                    <h1>Foutmelding</h1>
                    <p>
                        Helaas ging er iets mis met het verzenden van een of meerdere antwoorden. Geen zorgen, je voortgang tot nu toe is opgeslagen.
                        <br /><br />
                        We raden je aan je internetverbinding te controleren en daarna op de onderstaande knop te klikken. Mogelijk moet je hierna opnieuw inloggen.
                        <br /><br />
                        <button
                            style={{
                                background: 'red',
                                color: 'white',
                                padding: '.5rem 1rem'
                            }}
                            onClick={ () => { location.reload(); } }
                        >HERLADEN</button>
                    </p>
                </div>
            </div>
        );
    }
}

